import { http } from "../http/Http";
import { GetByFiltersArguments } from "../models/GetByFiltersArguments";
import { ServiceResponse } from "../models/ServiceResponse";
import { Container } from "../models/Container";
import { ContainersList } from "../models/ContainersList";

export class ContainerService{

    getContainersByFilters = async (ContainersFilter: GetByFiltersArguments): Promise<ServiceResponse<ContainersList[]>> => {
        const { data } = await http.post<ServiceResponse<ContainersList[]>>("Container/GetByFilters", ContainersFilter);
        return data;
    };

    getContainerById = async (entityNumber: string): Promise<Container> => {
        const { data } = await http.get<Container>(("container/GetByEntityNumber/" + entityNumber.toString()));
        return data;
    };
    
}